import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Box, Typography } from "@mui/material";
import logo from "../images/jnplogo.png";

const Loader = ({ loading }) => {
    return (
        <AnimatePresence>
            {loading && (
                <motion.div
                    initial={{ opacity: 0, filter: "grayscale(100%)" }}
                    animate={{
                        opacity: 1,
                        filter: "grayscale(0%)"
                    }}
                    exit={{ opacity: 0 }}
                    transition={{
                        opacity: { duration: 0.5 },
                        filter: { duration: 2.5, ease: "easeOut" }
                    }}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#f3f5f9",
                        zIndex: 9999,
                    }}
                >
                    {/* Centered Logo and Spinner Container */}
                    <Box
                        sx={{
                            position: "relative",
                            width: "220px",
                            height: "220px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {/* Spinning Outer Ring - Adjusted for perfect centering */}
                        <motion.div
                            animate={{ rotate: 360 }}
                            transition={{
                                duration: 2.5,
                                repeat: Infinity,
                                ease: "linear",
                            }}
                            style={{
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                borderRadius: "50%",
                                border: "2px solid rgba(255, 107, 0, 0.05)",
                                borderTop: "2px solid #FF6B00",
                                boxSizing: "border-box",
                            }}
                        />

                        {/* Pulsing Glow Background */}
                        <motion.div
                            animate={{
                                scale: [1, 1.1, 1],
                                opacity: [0.1, 0.2, 0.1],
                            }}
                            transition={{
                                duration: 2,
                                repeat: Infinity,
                                ease: "easeInOut",
                            }}
                            style={{
                                position: "absolute",
                                width: "80%",
                                height: "80%",
                                borderRadius: "50%",
                                background: "radial-gradient(circle, #FF6B00 0%, transparent 70%)",
                            }}
                        />

                        {/* Logo Image */}
                        <motion.div
                            animate={{
                                y: [0, -8, 0],
                            }}
                            transition={{
                                duration: 3,
                                repeat: Infinity,
                                ease: "easeInOut",
                            }}
                            style={{
                                width: "140px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 1,
                            }}
                        >
                            <img
                                src={logo}
                                alt="JobsnProfiles"
                                style={{
                                    width: "100%",
                                    height: "auto",
                                    filter: "drop-shadow(0 10px 20px rgba(0,0,0,0.08))",
                                }}
                            />
                        </motion.div>
                    </Box>

                    {/* Text and Progress Bar Container */}
                    <Box sx={{ mt: 4, display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <motion.div
                            animate={{ opacity: [0.5, 1, 0.5] }}
                            transition={{ duration: 2, repeat: Infinity }}
                        >
                            <Typography
                                sx={{
                                    color: "#1E293B",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    letterSpacing: "4px",
                                    textTransform: "uppercase",
                                    fontFamily: "'Poppins', sans-serif",
                                }}
                            >
                                Connecting You
                            </Typography>
                        </motion.div>

                        {/* Progress line */}
                        <Box
                            sx={{
                                width: "160px",
                                height: "2px",
                                backgroundColor: "#F1F5F9",
                                mt: 2,
                                borderRadius: "2px",
                                overflow: "hidden",
                                position: "relative",
                            }}
                        >
                            <motion.div
                                animate={{
                                    left: ["-100%", "100%"],
                                }}
                                transition={{
                                    duration: 1.5,
                                    repeat: Infinity,
                                    ease: "easeInOut",
                                }}
                                style={{
                                    position: "absolute",
                                    width: "40%",
                                    height: "100%",
                                    background: "linear-gradient(90deg, transparent, #FF6B00, transparent)",
                                }}
                            />
                        </Box>
                    </Box>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default Loader;
